export enum InstructionCategory {
  NewBusiness = 'New business',
  ClientMaintenance = 'Client maintenance',
  PlanMaintenance = 'Plan maintenance'
}

// All possible Statusses
export enum Status {
  // Stage 1 Statusses
  instructionReceived = 'Instruction received',

  // Stage 2 Statusses
  requirementVerification = 'Requirements being verified',
  requirementRequested = 'Outstanding requirements requested',
  requirementValidation = 'Validating new requirements received',

  // Stage 3 Statusses
  processingApplication = 'Processing application',
  processingInstruction = 'Processing instruction',
  bankDetailSent = 'Bank details sent',
  pendingContribution = 'Contribution pending ',

  // Stage 4 Statusses
  completed = 'Completed',
  instructionFinalised = 'Instruction finalised',
  purchasingUnits = 'Purchasing of units',

  // Cancelled Statusses
  instructionCancelled = 'Instruction cancelled',
  policyCancelled = 'Policy cancelled'
}
